module.exports = __webpack_public_path__ + "img/no-internet.4b157935.svg";